import { apiGet } from './client';
import type { EmployeeInvoiceDetail } from './employeeInvoices';

export interface FreelancerInvoiceSummary {
  userId: number;
  userName: string;
  email: string;
  month: number;
  year: number;
  state: 'open' | 'sent';
  totalHours: number;
  totalBilling: number;
  totalExpenses: number;
  totalExtraCosts: number;
  totalAmount: number;
  netAmount: number;
  // Phase 71 (SBH-01/02) admin-only salary split. `salaryAmount` is null when
  // no monthly salary is recorded; `invoiceAfterSalary` is the salary-aware
  // invoice base — max(0, totalBilling − totalExtraCosts − salaryAmount).
  // These live only on the admin/finance-gated freelancer types, never on the
  // self-service EmployeeInvoice DTOs (confidentiality guard).
  salaryAmount: number | null;
  // Phase 84 — which of net/gross/total-employer-cost `salaryAmount` came from.
  // Null when no salary is recorded. A bare figure is ambiguous exactly when it
  // matters, since all three are plausible numbers.
  deductedField: 'net' | 'gross' | 'total_cost' | 'none' | null;
  invoiceAfterSalary: number;
}

export interface FreelancerInvoiceDetail extends EmployeeInvoiceDetail {
  userId: number;
  userName: string;
  salaryAmount: number | null;
  deductedField: 'net' | 'gross' | 'total_cost' | 'none' | null;
  invoiceAfterSalary: number;
}

export async function getFreelancerInvoices(year: number, month: number): Promise<FreelancerInvoiceSummary[]> {
  const res = await apiGet<{ data: FreelancerInvoiceSummary[] }>(`/admin/freelancer-invoices?year=${year}&month=${month}`);
  return res.data;
}

export async function getFreelancerInvoiceDetail(userId: number, year: number, month: number): Promise<FreelancerInvoiceDetail> {
  const res = await apiGet<{ data: FreelancerInvoiceDetail }>(`/admin/freelancer-invoices/${userId}/${year}/${month}`);
  return res.data;
}
